
import React from 'react';
import { vehicleBrands } from '../../../data/vehicles';

const Step1_Vehicle = ({ formData, setFormData, handleChange, nextStep }) => {

  const handleBrandChange = (e) => {
    const brandName = e.target.value;
    setFormData(prev => ({
        ...prev,
        vehicleBrand: brandName,
        vehicleModel: '', // Reset model on brand change
        batteryCapacity: '', // Reset battery on brand change
    }));
  };

  const handleModelChange = (e) => {
    const modelName = e.target.value;
    const brand = vehicleBrands.find(b => b.name === formData.vehicleBrand);
    const model = brand?.models.find(m => m.name === modelName);

    if (model) {
        setFormData(prev => ({
            ...prev,
            vehicleModel: model.name,
            // Auto-fill vehicle type and battery capacity
            vehicleType: model.type === 'electrique' ? 'Voiture électrique' : 'Hybride rechargeable',
            batteryCapacity: model.batteryCapacity || '',
        }));
    } else {
        setFormData(prev => ({ ...prev, vehicleModel: modelName }));
    }
  };

  const availableBrands = vehicleBrands;
  const availableModels = formData.vehicleBrand 
    ? vehicleBrands.find(b => b.name === formData.vehicleBrand)?.models.filter(m => m.type === 'electrique' || m.type === 'hybride_rechargeable') || [] 
    : [];

  return (
    <div>
      <h2 className="text-2xl font-semibold text-gray-700 mb-6">Étape 1 : Votre véhicule</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        
        {/* Marque du véhicule */}
        <div className="col-span-1">
          <label htmlFor="vehicleBrand" className="block text-sm font-medium text-gray-600 mb-1">Marque</label>
          <select id="vehicleBrand" name="vehicleBrand" value={formData.vehicleBrand} onChange={handleBrandChange} className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition">
            <option value="">-- Sélectionnez une marque --</option>
            {availableBrands.map(brand => <option key={brand.id} value={brand.name}>{brand.name}</option>)}
          </select>
        </div>

        {/* Modèle du véhicule */}
        <div className="col-span-1">
          <label htmlFor="vehicleModel" className="block text-sm font-medium text-gray-600 mb-1">Modèle</label>
          <select id="vehicleModel" name="vehicleModel" value={formData.vehicleModel} onChange={handleModelChange} className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition" disabled={!formData.vehicleBrand}>
            <option value="">-- Sélectionnez un modèle --</option>
            {availableModels.map(model => <option key={model.id} value={model.name}>{model.name}</option>)}
          </select>
        </div>

        {/* Type de véhicule (auto-filled) */}
        <div className="col-span-1">
          <label htmlFor="vehicleType" className="block text-sm font-medium text-gray-600 mb-1">Type de véhicule</label>
          <input type="text" id="vehicleType" name="vehicleType" value={formData.vehicleType} readOnly disabled className="w-full p-3 border border-gray-200 bg-gray-100 rounded-lg" />
        </div>

        {/* Capacité de la batterie (auto-filled) */}
        <div className="col-span-1">
          <label htmlFor="batteryCapacity" className="block text-sm font-medium text-gray-600 mb-1">Capacité de la batterie (kWh)</label>
          <input type="number" id="batteryCapacity" name="batteryCapacity" value={formData.batteryCapacity} onChange={handleChange} placeholder="Ex: 52" className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition" />
        </div>

        {/* Année du véhicule */}
        <div className="col-span-1 md:col-span-2">
            <label htmlFor="vehicleYear" className="block text-sm font-medium text-gray-600 mb-1">Année du véhicule</label>
            <input type="number" id="vehicleYear" name="vehicleYear" value={formData.vehicleYear} onChange={handleChange} placeholder="Ex: 2023" className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition" />
        </div>
      </div>

      <div className="mt-8 flex justify-end">
        <button type="button" onClick={nextStep} className="px-8 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors">
          Suivant
        </button>
      </div>
    </div>
  );
};

export default Step1_Vehicle;
